<template>
  <div class="recruit">
    <template v-if="themeList && themeList.length > 0">
      <div class="img-item" @click="goRecruitDetail(item)" v-for="item in themeList" v-if="item.diffDay >= 0 && item.locationConfStatus != 0">
        <img :src="item.imgUrl" />
        <div class="desc">
          <p class="clearfix">
            <span class="name">{{item.locationConfTitle}}</span>
            <span v-if="item.diffDay > 0" class="end-line">{{item.diffDay}}天后结束</span>
            <span v-else class="end-line">活动即将结束</span>
          </p>
          <p class="time">{{item.startTime | date}}<span v-if="item.endTime"> 至 {{item.endTime | date}}</span></p>
        </div>
      </div>
    </template>
    <div class="recruit-title" v-if="hotList && hotList.length > 0">
      <span>热门活动专场</span>
    </div>
    <div class="img-item" @click="goRecruitDetail(item)" v-for="item in hotList" v-if="item.diffDay >= 0 && item.locationConfStatus != 0">
      <img :src="item.imgUrl" />
      <div class="desc">
        <p class="clearfix">
          <span class="name">{{item.locationConfTitle}}</span>
          <span v-if="item.diffDay > 0" class="end-line">{{item.diffDay}}天后结束</span>
          <span v-else class="end-line">活动即将结束</span>
        </p>
        <p class="time">{{item.startTime | date}}<span v-if="item.endTime"> 至 {{item.endTime | date}}</span></p>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.recruit{
  background: #f5f5f5;
  padding-bottom: 20px;
  width: 100%;
  .recruit-title{
    width: 80%;
    margin: 20px auto;
    font-size: 18px;
    color: #333;
    font-weight: bold;
    position: relative;
    text-align: center;
    &:after {
      display: block;
      content: '';
      width: 100%;
      height: 1px;
      background-color: #E6E6E6;
      position: absolute;
      top: 50%;
      margin-top: -1px;
      left: 0;
      z-index: 1;
    }
    span {
      position: relative;
      z-index: 2;
      padding: 0 10px;
      background-color: #f5f5f5;
    }
  }
  .img-item{
    width: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    img{
      width: 100%;
    }
    .desc{
      line-height: 20px;
      padding: 10px;
      background: #fff;
    }
    .name{
      font-size: 16px;
      color: #333;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 70%;
      float: left;
    }
    .end-line{
      font-size: 14px;
      color: #666;
      float: right;
    }
    .time{
      font-size: 14px;
      color: #999;
      margin-top: 10px;
    }
  }
  .img-item ~ .img-item{
    margin-bottom: 20px;
  }
}
</style>
<script>
import { getList } from '@/api/recruit';
import Moment from 'moment'
Moment.locale('zh-cn');

export default {
  name: "recruit-module",
  data(){
    return{
      themeList: [],
      hotList: []
    };
  },
  components: {},
  methods: {
    getTime(input){
      const m = Moment(input);
      return m.format('YYYY-MM-DD');
    },
    goRecruitDetail(item){
      if(item.linkUrl!='###'){
        location.href = item.linkUrl + '?s=' + this.getTime(item.startTime * 1) + '&e=' + this.getTime(item.endTime * 1) + '&d=' + item.diffDay;
      }
    },
    init(){
      let params = {
        menuKeys: 'hh_h5',
        locationKeys: 'hh_h5_special_active,hh_h5_special_hot',
        locationConfStatus:1
      };
      getList(params).then((res) => {
        if (res && res.advertisementViews.length > 0) {
          res.advertisementViews.forEach(item => {
            switch (item.locationKey) {
              case 'hh_h5_special_active':
                this.themeList.push(item);
                break;
              case 'hh_h5_special_hot':
                this.hotList.push(item);
                break;
              default:
                return false;
            }
          });
        }
      }).catch(err=>{});
    }
  },
  created() {
    this.init();

    this.$store.commit('comp/WX_SHARE',{
      title:'猎上专题活动 - 专场抢人，速提佣金',
      desc:'重新定义人才服务'
    });
  }
};
</script>
